"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedEvent = void 0;
var FeedEvent;
(function (FeedEvent) {
    FeedEvent["newFeatureAvailable"] = "newFeatureAvailable";
    FeedEvent["contactListDiscovery"] = "contactListDiscovery";
    FeedEvent["connectionRequestReceived"] = "connectionRequestReceived";
    FeedEvent["connectionRequestAccepted"] = "connectionRequestAccepted";
    FeedEvent["connectionCompletedPeerAssessment"] = "connectionCompletedPeerAssessment";
    FeedEvent["connectionNatureDiscovered"] = "connectionNatureDiscovered";
    FeedEvent["commentLiked"] = "commentLiked";
    FeedEvent["commentReplied"] = "commentReplied";
    FeedEvent["rewardLevelObtained"] = "rewardLevelObtained";
    FeedEvent["successfulInviteSignUp"] = "successfulInviteSignUp";
    FeedEvent["premiumPurchaseConfirmed"] = "premiumPurchaseConfirmed";
    FeedEvent["scoresUpdated"] = "scoresUpdated";
    FeedEvent["highRatingReceived"] = "highRatingReceived";
    FeedEvent["dailyReflectionReceived"] = "dailyReflectionReceived";
    FeedEvent["nudgeReceived"] = "nudgeReceived";
    FeedEvent["surveyLinkReceived"] = "surveyLinkReceived";
    FeedEvent["peerAssessmentRequestReceived"] = "peerAssessmentRequestReceived";
    FeedEvent["viewPeriodicQuiz"] = "viewPeriodicQuiz";
    FeedEvent["weeklyPublicProfileViews"] = "weeklyPublicProfileViews";
    FeedEvent["firstComment"] = "firstComment";
    FeedEvent["postLiked"] = "postLiked";
    FeedEvent["connectionPostCreated"] = "connectionPostCreated";
    FeedEvent["postCommented"] = "postCommented";
})(FeedEvent = exports.FeedEvent || (exports.FeedEvent = {}));
